import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { hasValidStoredSession } from '@lib/utils/authSession';

const ProtectedRoutes = () => {
  const location = useLocation();
  const authState = useSelector((state) => state?.auth);

  if (!hasValidStoredSession(authState)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoutes;
